import { getSelfExclusionReviewRequestHelpText } from './selfExclusionContent.util'

export type SelfExclusionFaq = {
  question: string
  answer: string
}

// Keep the self-exclusion FAQ content in one place so both the public page and the
// account page present the same guidance without copy drifting over time.
export const selfExclusionFaqs: SelfExclusionFaq[] = [
  {
    question: 'WHAT DOES SELF EXCLUSION DO?',
    answer:
      'Self exclusion restricts account access, stops online ordering, and prevents offers from being returned against the excluded mobile number.',
  },
  {
    question: 'WHEN DOES SELF EXCLUSION START?',
    answer:
      'Self exclusion starts immediately after you confirm the SMS code that is sent to your mobile number.',
  },
  {
    question: 'HOW DO I REQUEST A REVIEW LATER?',
    answer: getSelfExclusionReviewRequestHelpText(),
  },
]
